// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file dev/moment/presence/v1alpha1/store.proto (package dev.moment.presence.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message dev.moment.presence.v1alpha1.PresenceStore
 */
export class PresenceStore extends Message<PresenceStore> {
  /**
   * @generated from field: map<string, dev.moment.presence.v1alpha1.IdentifiedPresenceIndicator> indicators = 1;
   */
  indicators: { [key: string]: IdentifiedPresenceIndicator } = {};

  constructor(data?: PartialMessage<PresenceStore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.PresenceStore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "indicators", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: IdentifiedPresenceIndicator} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PresenceStore {
    return new PresenceStore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PresenceStore {
    return new PresenceStore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PresenceStore {
    return new PresenceStore().fromJsonString(jsonString, options);
  }

  static equals(a: PresenceStore | PlainMessage<PresenceStore> | undefined, b: PresenceStore | PlainMessage<PresenceStore> | undefined): boolean {
    return proto3.util.equals(PresenceStore, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.PresenceIndicator
 */
export class PresenceIndicator extends Message<PresenceIndicator> {
  /**
   * @generated from field: double head = 1;
   */
  head = 0;

  /**
   * @generated from field: double anchor = 2;
   */
  anchor = 0;

  /**
   * @generated from field: double version = 3;
   */
  version = 0;

  /**
   * @generated from field: string client_id = 4;
   */
  clientId = "";

  constructor(data?: PartialMessage<PresenceIndicator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.PresenceIndicator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "head", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "anchor", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PresenceIndicator {
    return new PresenceIndicator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PresenceIndicator {
    return new PresenceIndicator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PresenceIndicator {
    return new PresenceIndicator().fromJsonString(jsonString, options);
  }

  static equals(a: PresenceIndicator | PlainMessage<PresenceIndicator> | undefined, b: PresenceIndicator | PlainMessage<PresenceIndicator> | undefined): boolean {
    return proto3.util.equals(PresenceIndicator, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.IdentifiedPresenceIndicator
 */
export class IdentifiedPresenceIndicator extends Message<IdentifiedPresenceIndicator> {
  /**
   * @generated from field: double head = 1;
   */
  head = 0;

  /**
   * @generated from field: double anchor = 2;
   */
  anchor = 0;

  /**
   * @generated from field: double version = 3;
   */
  version = 0;

  /**
   * @generated from field: string client_id = 4;
   */
  clientId = "";

  /**
   * @generated from field: string user_id = 5;
   */
  userId = "";

  constructor(data?: PartialMessage<IdentifiedPresenceIndicator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.IdentifiedPresenceIndicator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "head", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "anchor", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IdentifiedPresenceIndicator {
    return new IdentifiedPresenceIndicator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IdentifiedPresenceIndicator {
    return new IdentifiedPresenceIndicator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IdentifiedPresenceIndicator {
    return new IdentifiedPresenceIndicator().fromJsonString(jsonString, options);
  }

  static equals(a: IdentifiedPresenceIndicator | PlainMessage<IdentifiedPresenceIndicator> | undefined, b: IdentifiedPresenceIndicator | PlainMessage<IdentifiedPresenceIndicator> | undefined): boolean {
    return proto3.util.equals(IdentifiedPresenceIndicator, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.UpdatePresenceRequest
 */
export class UpdatePresenceRequest extends Message<UpdatePresenceRequest> {
  /**
   * @generated from field: dev.moment.presence.v1alpha1.PresenceIndicator indicator = 1;
   */
  indicator?: PresenceIndicator;

  constructor(data?: PartialMessage<UpdatePresenceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.UpdatePresenceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "indicator", kind: "message", T: PresenceIndicator },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePresenceRequest {
    return new UpdatePresenceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePresenceRequest {
    return new UpdatePresenceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePresenceRequest {
    return new UpdatePresenceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePresenceRequest | PlainMessage<UpdatePresenceRequest> | undefined, b: UpdatePresenceRequest | PlainMessage<UpdatePresenceRequest> | undefined): boolean {
    return proto3.util.equals(UpdatePresenceRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.UpdatePresenceResponse
 */
export class UpdatePresenceResponse extends Message<UpdatePresenceResponse> {
  constructor(data?: PartialMessage<UpdatePresenceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.UpdatePresenceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePresenceResponse {
    return new UpdatePresenceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePresenceResponse {
    return new UpdatePresenceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePresenceResponse {
    return new UpdatePresenceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePresenceResponse | PlainMessage<UpdatePresenceResponse> | undefined, b: UpdatePresenceResponse | PlainMessage<UpdatePresenceResponse> | undefined): boolean {
    return proto3.util.equals(UpdatePresenceResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.GetPresenceRequest
 */
export class GetPresenceRequest extends Message<GetPresenceRequest> {
  constructor(data?: PartialMessage<GetPresenceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.GetPresenceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPresenceRequest {
    return new GetPresenceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPresenceRequest {
    return new GetPresenceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPresenceRequest {
    return new GetPresenceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPresenceRequest | PlainMessage<GetPresenceRequest> | undefined, b: GetPresenceRequest | PlainMessage<GetPresenceRequest> | undefined): boolean {
    return proto3.util.equals(GetPresenceRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.GetPresenceResponse
 */
export class GetPresenceResponse extends Message<GetPresenceResponse> {
  /**
   * @generated from field: map<string, dev.moment.presence.v1alpha1.IdentifiedPresenceIndicator> indicators = 1;
   */
  indicators: { [key: string]: IdentifiedPresenceIndicator } = {};

  constructor(data?: PartialMessage<GetPresenceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.GetPresenceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "indicators", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: IdentifiedPresenceIndicator} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPresenceResponse {
    return new GetPresenceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPresenceResponse {
    return new GetPresenceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPresenceResponse {
    return new GetPresenceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPresenceResponse | PlainMessage<GetPresenceResponse> | undefined, b: GetPresenceResponse | PlainMessage<GetPresenceResponse> | undefined): boolean {
    return proto3.util.equals(GetPresenceResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.ConnectRequest
 */
export class ConnectRequest extends Message<ConnectRequest> {
  /**
   * @generated from field: string client_id = 4;
   */
  clientId = "";

  constructor(data?: PartialMessage<ConnectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.ConnectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 4, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectRequest {
    return new ConnectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectRequest {
    return new ConnectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectRequest {
    return new ConnectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectRequest | PlainMessage<ConnectRequest> | undefined, b: ConnectRequest | PlainMessage<ConnectRequest> | undefined): boolean {
    return proto3.util.equals(ConnectRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.presence.v1alpha1.ConnectResponse
 */
export class ConnectResponse extends Message<ConnectResponse> {
  constructor(data?: PartialMessage<ConnectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.presence.v1alpha1.ConnectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectResponse {
    return new ConnectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectResponse {
    return new ConnectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectResponse {
    return new ConnectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectResponse | PlainMessage<ConnectResponse> | undefined, b: ConnectResponse | PlainMessage<ConnectResponse> | undefined): boolean {
    return proto3.util.equals(ConnectResponse, a, b);
  }
}

